import * as React from 'react';
import { getDragInfoTipText } from './getDragInfoTipText';
import { isDragging } from '../../actions/isDragging';
import { observer } from 'mobx-react-lite';
import { SurfaceDragDropState } from 'owa-calendar-surface-dategrid';

let styles = require('./DragDropInfoTip.scss');

const infoTipOffsetTop = 10;
const infoTipOffsetLeft = 10;

/**
 * Props for the info tip component
 */
export interface DragDropInfoTipProps {
    dragDropState: SurfaceDragDropState;
}

/**
 * Info tooltip for a drag/drop operation. Shows the new time of the event as the user drags it.
 */
const DragDropInfoTip = observer(function DragDropInfoTip(props: DragDropInfoTipProps) {
    let { dragDropState } = props;
    if (!isDragging(dragDropState) || !dragDropState.droppableType) {
        return null;
    }

    let dragPosition = dragDropState.dragPosition;
    if (!dragPosition) {
        return null;
    }

    let positionStyles: React.CSSProperties = {
        top: dragPosition.y + infoTipOffsetTop,
        left: dragPosition.x + infoTipOffsetLeft,
    };

    let infoTipText = getDragInfoTipText(dragDropState.helperItemModel);
    return (
        <div className={styles.dragTip} style={positionStyles}>
            {infoTipText}
        </div>
    );
});
export default DragDropInfoTip;
